const errorResolverMap = {
  'invalid mobile number parsed, mobile number must be 12 digits': 'Please enter a valid phone number',
};

export default errorResolverMap;
